import styled from "styled-components";
import { FillerContainerStyled, CategoryHeaderStyled, ItemContainerStyled, ItemEnglishTitleStyled, ItemImageContainerStyled, PriceContainerStyled, ItemEnglishDescriptionStyled, CategoryContainerStyled, ArabicContainerStyled, ItemArabicTitleStyled, ItemArabicDescriptionStyled } from "./CommonStyled";
import {scones} from "../../../data/lbCategories/a-la-carte/menuItems";

function BoutiqueScones({}) {
    return (
        <>
        <CategoryContainerStyled>
            {/* <CategoryHeaderStyled>
                <span>Scones</span>
            </CategoryHeaderStyled> */}
                {
                    scones.map(({item_img_src, name_en, description_en, name_ar, description_ar, price, currency}) => {
                        return (
                            <ItemContainerStyled>
                                <ItemImageContainerStyled>
                                    <img src = {item_img_src} alt = {name_en}/>
                                </ItemImageContainerStyled>
                                <ItemEnglishTitleStyled>
                                    {name_en}
                                    <PriceContainerStyled>
                                        {price}
                                        <span>{currency}</span>
                                    </PriceContainerStyled>
                                </ItemEnglishTitleStyled>
                                <ArabicContainerStyled>
                                    <ItemArabicTitleStyled>
                                        {name_ar}
                                    </ItemArabicTitleStyled>
                                </ArabicContainerStyled>
                                <FillerContainerStyled/>
                            </ItemContainerStyled>
                        )
                    })
                }

            </CategoryContainerStyled>
        </>
    )
}


export default BoutiqueScones;